import { sis_giaidoan } from './../models/response/so-diem/sis_giaidoan';
import { BaseCRUDApi } from "./baseCRUDApi";

class GiaiDoanApi extends BaseCRUDApi<sis_giaidoan>{
    constructor(path: string) {
        super(path)
    }
}
export const giaiDoanApi = new GiaiDoanApi('giai-doan');